<dx-popup title="Customer" [width]="1200" [height]="800" [(visible)]="visible" [hideOnOutsideClick]="false" (onHiding)="onHiding($event)">
    <dxi-popup-toolbar-item widget="dxButton" location="after" [options]="{ text: 'Save', type: 'success', accessKey: 's', onClick: save }">
    </dxi-popup-toolbar-item>
    @if (true) {
        <dxi-popup-toolbar-item widget="dxButton" location="after" [options]="{ text: 'Cancel', type: 'danger', onClick: cancel }">
        </dxi-popup-toolbar-item>
    }
    <div *dxTemplate="let data of 'content'">
        <app-customer-detail #customerDetailComponent [showAsDialog]="true" [dialogKey]="dialogKey"> </app-customer-detail>
    </div>
</dx-popup>
